import {Breadcrumbs, ErrorPopup, Title} from '@management-ui/core';
import React from 'react';
import routes from '../../../../routes';

const Wrapper = ({title, loading, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading}/>
      {children}
      <ErrorPopup errors={['trust']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Trusts', link: routes.trusts.index}
];

export default Wrapper;
